/* SUR+ rail, runway and piece view v4.
   Garments hang on swivel hooks and swing like real ones as the rail moves; every glide is a spring that carries
   the speed of your finger. One time-based motion core, so it feels the same at 60 and 120 Hz, with a finger,
   a mouse or a trackpad. (Garment cut-outs come from surplus-cut.js.) */
(function(){
var w=window,d=document;
if(w.SPR)return;w.SPR=1;
var mm=function(q){return !!(w.matchMedia&&w.matchMedia(q).matches)};
var reduce=mm('(prefers-reduced-motion: reduce)'),fine=mm('(hover: hover) and (pointer: fine)');
function el(t,c,x){var e=d.createElement(t);if(c)e.className=c;if(x!=null)e.textContent=x;return e}
function clamp(v,a,b){return v<a?a:(v>b?b:v)}
function pad(n){return (n<10?'0':'')+n}
function data(li){var s=li&&li.querySelector('script[data-sp-p]');if(!s)return null;try{return JSON.parse(s.textContent)}catch(e){return null}}
var ARROW='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';

/* cut-outs come from surplus-cut.js (loaded on every page) */
function cut(u){return w.SPCut?w.SPCut.cut(u):Promise.resolve(null)}
function lift(im){if(w.SPCut)w.SPCut.lift(im)}

/* ---------- motion core ---------- */
var STEP=1/240;
/* calls step(dt) once a frame for as long as it returns true; dt is in seconds and capped, so a slow frame never jumps */
function ticker(step){var raf=0,t0=0;
 function frame(t){raf=0;var dt=t0?Math.min((t-t0)/1000,0.05):1/60;t0=t;if(step(dt))raf=requestAnimationFrame(frame);else t0=0}
 return function(){if(!raf)raf=requestAnimationFrame(frame)}}
/* pulls s.x toward s.t like a spring (stiffness k, damping c), in small fixed steps so it stays stable at any frame rate */
function spring(s,k,c,dt){for(var m=Math.ceil(dt/STEP),h=dt/m,i=0;i<m;i++){s.v+=(k*(s.t-s.x)-c*s.v)*h;s.x+=s.v*h}}
function settled(s,e){if(Math.abs(s.t-s.x)<e&&Math.abs(s.v)<e*4){s.x=s.t;s.v=0;return true}return false}
/* finger speed in px/s over the last 100 ms; 0 when the finger stopped before it lifted */
function tracker(){var q=[];return {
 add:function(x,t){q.push([x,t]);if(q.length>24)q.shift()},
 vel:function(){var m=q.length;if(m<2)return 0;var b=q[m-1],a=b;for(var i=m-2;i>=0&&b[1]-q[i][1]<=100;i--)a=q[i];var dt=b[1]-a[1];return dt>=10?(b[0]-a[0])/dt*1000:0},
 clear:function(){q.length=0}}}
/* a soft stop past either end of the rail: the further you pull, the less it gives */
function band(p,n){var r=0.45;if(p<0)return -r*(1-Math.exp(p/r));if(p>n-1)return n-1+r*(1-Math.exp((n-1-p)/r));return p}
function ease(u){return u*u*(3-2*u)}
function rnd(i){var x=Math.sin(i*127.1+311.7)*43758.5453;return x-Math.floor(x)}
/* sideways wheel or trackpad travel in px; 0 when the gesture is mostly up and down, so the page scrolls as usual */
function sideways(e){var k=e.deltaMode===1?16:(e.deltaMode===2?400:1),x=e.deltaX*k,y=e.deltaY*k;if(e.shiftKey&&!x){x=y;y=0}return Math.abs(x)>Math.abs(y)?x:0}

/* ---------- the rail: garments hang side-on, the centred one turns to face you ---------- */
function rail(root){
 var list=root.querySelector('.sp-rail__list'),stage=root.querySelector('.sp-rail__stage'),items=[].slice.call(root.querySelectorAll('.sp-rail__item')),dots=root.querySelector('.sp-rail__dots');
 if(!list||!items.length)return;
 var n=items.length;
 root.classList.add('sp-rail--live');
 /* each garment: where its hook is and how fast it moves, its swing on the hook, its price tag's swing, a hover peek */
 var G=items.map(function(it,i){
  var a=it.querySelector('.sp-rail__link');if(a)a.setAttribute('draggable','false');
  var im=it.querySelector('.sp-rail__img img');if(im)lift(im);
  return {li:it,sw:it.querySelector('.sp-rail__swing'),fig:it.querySelector('.sp-rail__fig'),tag:it.querySelector('.sp-rail__tag'),
   x:null,v:0,a:0,th:0,om:0,ta:0,tv:0,pk:{x:0,v:0,t:0},
   w0:2*Math.PI/(1.2+rnd(i)*0.3),w1:2*Math.PI/(0.74+rnd(i+9)*0.18),c:{}};
 });
 var pv=el('button','sp-rail__nav sp-rail__nav--prev'),nx=el('button','sp-rail__nav sp-rail__nav--next');
 pv.type=nx.type='button';pv.setAttribute('aria-label','Previous piece');nx.setAttribute('aria-label','Next piece');pv.innerHTML=nx.innerHTML=ARROW;
 if(stage){stage.appendChild(pv);stage.appendChild(nx)}
 var dl=[];
 if(dots){dots.textContent='';items.forEach(function(_,i){var b=el('button','sp-rail__dot');b.type='button';b.setAttribute('aria-label','Show piece '+(i+1));b.addEventListener('click',function(){to(i)});dots.appendChild(b);dl.push(b)})}
 /* layout: S is the spacing between hooks, P the extra room the facing garment needs, RY how far the others are turned */
 var S=190,GW=270,P=110,RY=66,half=600;
 function measure(){S=items[0].offsetWidth||S;GW=(G[0].fig&&G[0].fig.offsetWidth)||S*1.42;P=Math.max(0,GW*0.78-S+26);RY=list.clientWidth<750?68:66;half=list.clientWidth/2;for(var k=0;k<n;k++)G[k].x=null}
 function X(o){var a=o<0?-o:o,x=a*S+P*ease(a<1?a:1);return o<0?-x:x}
 function dX(o){var a=o<0?-o:o;return a<1?S+6*P*a*(1-a):S}
 function invX(x){var a=x<0?-x:x,o;if(a>=S+P)o=(a-P)/S;else{var lo=0,hi=1;for(var j=0;j<24;j++){var m=(lo+hi)/2;if(m*S+P*ease(m)<a)lo=m;else hi=m}o=(lo+hi)/2}return x<0?-o:o}
 var pos={x:0,v:0,t:0},K=reduce?320:110,C=reduce?2*Math.sqrt(320):2*0.8*Math.sqrt(110),soft=0;
 var active=-1,front=-1,drag=null,moved=false,caught=false,hover=-1,wraw=null,wt=0,tr=tracker();
 var kick=ticker(function(dt){
  var busy=true;
  if(!(drag&&drag.on)&&wraw===null){var k=soft?30:K;spring(pos,k,soft?2*0.92*Math.sqrt(30):C,dt);if(settled(pos,0.0004)){soft=0;busy=false}}
  if(render(dt))busy=true;
  sync();
  return busy;
 });
 function render(dt){
  var p=pos.x,busy=false,vis=half+GW,f1=1-Math.exp(-dt/0.035),f2=1-Math.exp(-dt/0.05);
  for(var k=0;k<n;k++){
   var g=G[k],o=k-p,a=o<0?-o:o,u=ease(a<1?a:1),x=X(o),c=g.c;
   /* the hook's speed and acceleration along the rail, lightly smoothed so finger jitter does not shake the garments */
   if(g.x===null||dt<=0){g.x=x;g.v=0;g.a=0}
   else{var v=g.v+((x-g.x)/dt-g.v)*f1;g.a+=((v-g.v)/dt-g.a)*f2;g.v=v;g.x=x}
   /* swing: a damped pendulum on the hook, pushed by that acceleration; the tag is a lighter pendulum that lags behind */
   if(!reduce&&dt>0){
    var e0=10*Math.tanh(g.a*0.00014),e1=12*Math.tanh(g.a*0.00011);
    for(var m=Math.ceil(dt/STEP),h=dt/m,j=0;j<m;j++){
     g.om+=(-g.w0*g.w0*(g.th-e0)-0.32*g.w0*g.om)*h;g.th+=g.om*h;
     g.tv+=(-g.w1*g.w1*(g.ta-e1)-0.22*g.w1*g.tv)*h;g.ta+=g.tv*h;
    }
    if(Math.abs(g.th)+Math.abs(g.ta)+(Math.abs(g.om)+Math.abs(g.tv))*0.15>0.02||Math.abs(g.a)>30)busy=true;else g.th=g.om=g.ta=g.tv=0;
   }
   /* desktop: hovering a side-on piece turns it a little toward you */
   g.pk.t=k===hover&&k!==front&&!(drag&&drag.on)?1:0;
   if(dt>0&&(g.pk.x!==g.pk.t||g.pk.v)){spring(g.pk,240,2*0.9*Math.sqrt(240),dt);if(!settled(g.pk,0.001))busy=true}
   var on=(x<0?-x:x)<vis;
   if(c.on!==on){g.li.style.visibility=on?'':'hidden';c.on=on}
   if(!on)continue;
   var t=x.toFixed(1);if(c.x!==t){g.li.style.transform='translate3d('+t+'px,0,0)';c.x=t}
   var z=100-Math.round(a*10);if(c.z!==z){g.li.style.zIndex=z;c.z=z}
   if(g.fig){var ry=RY*u*(1-0.42*g.pk.x),sc=1.03-0.08*u+0.02*g.pk.x*u;t=ry.toFixed(2)+'deg) scale('+sc.toFixed(4);if(c.f!==t){g.fig.style.transform='perspective(1100px) rotateY('+t+')';c.f=t}}
   if(g.sw){t=Math.abs(g.th)<0.005?'':'rotate('+g.th.toFixed(2)+'deg)';if(c.s!==t){g.sw.style.transform=t;c.s=t}}
   if(g.tag){var r=g.ta-g.th;t=Math.abs(r)<0.005?'':'rotate('+r.toFixed(2)+'deg)';if(c.t!==t){g.tag.style.transform=t;c.t=t}}
  }
  return busy;
 }
 /* the nearest piece is active (dots, arrows); it faces you, with its name and price, once the rail comes to rest on it */
 function sync(){var i=clamp(Math.round(pos.x),0,n-1);setActive(i);face(!(drag&&drag.on)&&wraw===null&&Math.abs(pos.x-i)<0.2&&Math.abs(pos.v)<2.5?i:-1)}
 function setActive(i){if(i===active)return;active=i;dl.forEach(function(b,k){b.classList.toggle('is-on',k===i)});pv.disabled=i<=0;nx.disabled=i>=n-1;for(var k=0;k<n;k++)items[k].classList.toggle('is-active',k===i)}
 function face(i){if(i===front)return;front=i;root.classList.toggle('is-facing',i>=0);for(var k=0;k<n;k++)items[k].classList.toggle('is-front',k===i)}
 function to(i){pos.t=clamp(Math.round(i),0,n-1);kick()}
 pv.addEventListener('click',function(){to(pos.t-1)});nx.addEventListener('click',function(){to(pos.t+1)});
 /* drag with a finger or a mouse: the garment you grab stays under your finger, the throw carries on as a glide */
 list.addEventListener('pointerdown',function(e){
  if(e.button!==0||drag)return;
  var q=list.getBoundingClientRect(),k=clamp(Math.round(pos.x+invX(e.clientX-q.left-q.width/2)),0,n-1);
  drag={id:e.pointerId,x0:e.clientX,y0:e.clientY,on:false,k:k,xg:0};moved=false;caught=false;tr.clear();tr.add(e.clientX,e.timeStamp);
  /* touching a gliding rail stops it under the finger */
  if(Math.abs(pos.v)>0.6){pos.t=pos.x;pos.v=0;caught=moved=true;kick()}
 });
 list.addEventListener('pointermove',function(e){
  if(!drag||e.pointerId!==drag.id)return;
  var dx=e.clientX-drag.x0,dy=e.clientY-drag.y0;
  if(!drag.on){
   if(Math.abs(dx)>6&&Math.abs(dx)>Math.abs(dy)*1.15){drag.on=moved=true;drag.x0=e.clientX;drag.xg=X(drag.k-pos.x);pos.v=0;dx=0;try{list.setPointerCapture(e.pointerId)}catch(x){}root.classList.add('is-drag');face(-1)}
   else{if(Math.abs(dy)>10&&e.pointerType!=='mouse'){drag=null;if(caught)to(pos.x)}return}
  }
  tr.add(e.clientX,e.timeStamp);
  pos.x=band(drag.k-invX(drag.xg+dx),n);pos.t=pos.x;kick();
 });
 function up(e){
  if(!drag||e.pointerId!==drag.id)return;var dd=drag;drag=null;
  if(!dd.on){if(caught)to(pos.x);return}
  root.classList.remove('is-drag');
  if(e.type!=='pointercancel')tr.add(e.clientX,e.timeStamp);
  var vi=e.type==='pointercancel'?0:clamp(-tr.vel()/dX(dd.k-pos.x),-30,30);
  pos.v=vi;to(pos.x+clamp(vi*0.24,-3.4,3.4));
 }
 list.addEventListener('pointerup',up);list.addEventListener('pointercancel',up);
 list.addEventListener('dragstart',function(e){e.preventDefault()});
 /* trackpads: a sideways two-finger swipe slides the rail, and it settles on a piece when the swipe ends */
 list.addEventListener('wheel',function(e){
  var dx=sideways(e);if(!dx||(drag&&drag.on))return;e.preventDefault();
  if(wraw===null)wraw=pos.x;
  wraw=clamp(wraw+dx/dX(Math.round(pos.x)-pos.x),-1.5,n+0.5);pos.x=band(wraw,n);pos.t=pos.x;pos.v=0;
  clearTimeout(wt);wt=setTimeout(function(){wraw=null;to(pos.x)},130);kick();
 },{passive:false});
 if(fine){
  list.addEventListener('pointerover',function(e){if(e.pointerType!=='mouse')return;var li=e.target.closest&&e.target.closest('.sp-rail__item'),k=items.indexOf(li);if(k!==hover){hover=k;kick()}});
  list.addEventListener('pointerleave',function(){if(hover!==-1){hover=-1;kick()}});
 }
 list.addEventListener('click',function(e){
  if(moved){e.preventDefault();e.stopPropagation();moved=false;return}
  var a=e.target.closest&&e.target.closest('.sp-rail__link');if(!a)return;
  if(e.metaKey||e.ctrlKey||e.shiftKey)return;
  var li=a.closest('.sp-rail__item'),i=items.indexOf(li);if(i<0)return;
  e.preventDefault();e.stopPropagation();
  if(i!==front){to(i);return}
  var p=data(li);if(p)openLook({root:root,items:items,i:i,p:p,to:to});
 },true);
 root.addEventListener('keydown',function(e){
  if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft')return;
  var i=clamp(pos.t+(e.key==='ArrowRight'?1:-1),0,n-1);if(i===pos.t)return;e.preventDefault();to(i);
  var a=items[i].querySelector('.sp-rail__link');if(a)a.focus({preventScroll:true});
 });
 list.addEventListener('focusin',function(e){if(drag&&drag.on)return;var li=e.target.closest&&e.target.closest('.sp-rail__item'),i=items.indexOf(li);if(i>=0&&i!==pos.t&&e.target.matches(':focus-visible'))to(i)});
 function start(){
  measure();var vis=Math.max(1,Math.round(list.clientWidth/(S||1)));
  var i=Math.min(Math.floor((vis-1)/2),Math.floor((n-1)/2));
  pos.x=pos.t=i;pos.v=0;render(0);sync();
 }
 start();
 if(w.ResizeObserver){var rw=list.clientWidth;new ResizeObserver(function(){if(list.clientWidth===rw)return;rw=list.clientWidth;measure();render(0)}).observe(list)}
 /* arrive: the pieces slide in along the rail and swing forward as they come to rest */
 var q=root.getBoundingClientRect();
 if(!reduce&&'IntersectionObserver' in w&&q.top>w.innerHeight*0.9){
  root.classList.add('is-pre');
  var io=new IntersectionObserver(function(es){if(!es[0].isIntersecting)return;io.disconnect();
   var s=pos.t;items.forEach(function(it,k){it.style.setProperty('--d',Math.abs(k-s))});
   pos.x=s-1.3;pos.v=0;soft=1;for(var k=0;k<n;k++)G[k].x=null;render(0);
   root.classList.add('is-intro');root.classList.remove('is-pre');kick();
   setTimeout(function(){root.classList.remove('is-intro')},1900)},{threshold:0.25});
  io.observe(root);
 }
}

/* ---------- piece view: the garment lifts off the rail, turn it to see the back ---------- */
var look=null;
function buildLook(){
 look=el('dialog','sp-look');look.setAttribute('aria-label','Piece');
 look.innerHTML='<div class="sp-look__bg"></div>'+
  '<button type="button" class="sp-look__close" data-x><span>Close</span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'+
  '<div class="sp-look__scroll">'+
   '<div class="sp-look__stage" data-stage><div class="sp-look__lift" data-lift>'+
    '<svg class="sp-look__hook" viewBox="0 0 40 52" aria-hidden="true" focusable="false"><path d="M20 52V31c0-5 8-7 8-15a8 8 0 0 0-16 0"/></svg>'+
    '<div class="sp-look__card" data-card><img class="sp-look__face" alt="" data-front draggable="false"><img class="sp-look__face sp-look__face--back" alt="" data-back draggable="false"></div>'+
   '</div></div>'+
   '<div class="sp-look__info">'+
    '<p class="sp-look__count" data-count></p><h2 class="sp-look__title" data-title></h2><p class="sp-look__price" data-price></p><p class="sp-stock sp-look__stock" data-stock hidden></p>'+
    '<div class="sp-look__tabs" role="group" aria-label="Side" data-tabs><button type="button" data-side="0" aria-pressed="true">Front</button><button type="button" data-side="1" aria-pressed="false">Back</button></div>'+
    '<p class="sp-look__lbl" data-lbl>Size</p><div class="sp-look__sizes" data-sizes></div>'+
    '<button type="button" class="sp-btn sp-look__add" data-add>Add to bag</button><p class="sp-eta sp-look__eta" data-eta hidden></p><p class="sp-look__msg" aria-live="polite" data-msg></p>'+
    '<a class="sp-linkbtn sp-look__more" data-more href="#">View full details</a>'+
   '</div>'+
  '</div>';
 d.body.appendChild(look);
 var q=function(s){return look.querySelector(s)};
 var L=look._={x:q('[data-x]'),stage:q('[data-stage]'),lift:q('[data-lift]'),card:q('[data-card]'),front:q('[data-front]'),back:q('[data-back]'),count:q('[data-count]'),title:q('[data-title]'),price:q('[data-price]'),stock:q('[data-stock]'),tabs:q('[data-tabs]'),lbl:q('[data-lbl]'),sizes:q('[data-sizes]'),add:q('[data-add]'),eta:q('[data-eta]'),msg:q('[data-msg]'),more:q('[data-more]')};
 L.x.addEventListener('click',shut);
 look.addEventListener('cancel',function(e){e.preventDefault();shut()});
 look.addEventListener('keydown',function(e){if(L.tabs.hidden)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){if(e.target.closest&&e.target.closest('.sp-look__sizes'))return;e.preventDefault();side(look._s?0:1)}});
 [].forEach.call(L.tabs.children,function(b){b.addEventListener('click',function(){side(+b.dataset.side)})});
 /* drag the garment sideways to spin it */
 var dr=null;
 L.stage.addEventListener('pointerdown',function(e){if(L.tabs.hidden||(e.button&&e.button!==0))return;dr={x:e.clientX,y:e.clientY,id:e.pointerId,on:false,b:look._s?180:0}});
 L.stage.addEventListener('pointermove',function(e){if(!dr||dr.id!==e.pointerId)return;var dx=e.clientX-dr.x,dy=e.clientY-dr.y;
  if(!dr.on){if(Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)){dr.on=true;try{L.stage.setPointerCapture(dr.id)}catch(x){}L.card.style.transition='none'}else if(Math.abs(dy)>10){dr=null;return}else return}
  dr.ry=dr.b+dx*0.6;L.card.style.transform='rotateY('+dr.ry.toFixed(1)+'deg)'});
 function endSpin(e){if(!dr||dr.id!==e.pointerId)return;var r=dr;dr=null;if(!r.on)return;L.card.style.transition='';L.card.style.transform='';var a=((r.ry%360)+360)%360;side(a>90&&a<270?1:0,true)}
 L.stage.addEventListener('pointerup',endSpin);L.stage.addEventListener('pointercancel',endSpin);
 L.add.addEventListener('click',function(){
  var v=look._v;if(!v){L.msg.textContent='Pick a size first.';return}
  L.add.disabled=true;L.add.textContent='Adding...';L.msg.textContent='';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v,quantity:1}]})})
  .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
  .then(function(res){L.add.disabled=false;L.add.textContent='Add to bag';
   if(!res.ok){L.msg.textContent=(res.j&&res.j.description)||'Could not add this piece. Try again.';return}
   /* the piece goes into the bag: the view closes and the garment flies to the bag icon */
   var face=look._s?L.back:L.front,fr=face.getBoundingClientRect(),fu=face.currentSrc||face.src;
   if(w.SPFly){shut(true);w.SPFly.fly(fu,fr);w.SPFly.refreshBag();w.SPFly.toast('Added to bag');return}
   L.msg.textContent='';var a=el('a','sp-link','Added. View bag');a.href='/cart';L.msg.appendChild(a);
  }).catch(function(){L.add.disabled=false;L.add.textContent='Add to bag';L.msg.textContent='Could not add this piece. Try again.'});
 });
}
function side(s,fromSpin){var L=look._;look._s=s;L.card.classList.toggle('is-back',s===1);[].forEach.call(L.tabs.children,function(b){b.setAttribute('aria-pressed',String(+b.dataset.side===s))})}
function srcImg(ctx){return ctx.items[ctx.i].querySelector('.sp-rail__img img')}
function contentRect(img){var r=img.getBoundingClientRect(),nw=img.naturalWidth,nh=img.naturalHeight;if(!nw||!nh)return r;var s=Math.min(r.width/nw,r.height/nh),cw=nw*s,ch=nh*s;return {left:r.left+(r.width-cw)/2,top:r.top,width:cw,height:ch}}
/* the transform that puts the piece view's garment exactly over the rail garment */
function flip(from){var L=look._;L.lift.style.transform='';var lr=L.lift.getBoundingClientRect(),fr=L.front.getBoundingClientRect();if(!fr.width)return '';
 var s=from.width/fr.width,tx=from.left-lr.left-(fr.left-lr.left)*s,ty=from.top-lr.top-(fr.top-lr.top)*s;
 return 'translate3d('+tx.toFixed(1)+'px,'+ty.toFixed(1)+'px,0) scale('+s.toFixed(4)+')'}
function openLook(ctx){
 if(!look)buildLook();var L=look._,p=ctx.p,src=srcImg(ctx);
 look._ctx=ctx;look._p=p;look._v=null;
 L.count.textContent=pad(ctx.i+1)+' / '+pad(ctx.items.length);L.title.textContent=p.title;L.price.textContent=p.price;L.more.href=p.url;L.msg.textContent='';
 L.stock.textContent=p.stock||'';L.stock.hidden=!p.stock;L.stock.classList.toggle('is-last',/^Last/.test(p.stock||''));
 var f=(p.images&&p.images[0])||'',bk=(p.images&&p.images[1])||'';
 look.classList.toggle('is-uncut',!(src&&src.dataset.spSrc));
 L.front.src=(src&&src.dataset.spSrc)||f;L.front.alt=p.title;
 cut(f).then(function(u){if(u&&look._p===p){L.front.src=u;look.classList.remove('is-uncut')}});
 L.tabs.hidden=!bk;L.back.removeAttribute('src');
 if(bk)cut(bk).then(function(u){if(look._p===p)L.back.src=u||bk});
 side(0);
 L.sizes.textContent='';var vs=p.variants||[],single=vs.length===1&&/default/i.test(vs[0].t);
 L.lbl.hidden=single;
 vs.forEach(function(v){
  if(single){look._v=v.a?v.id:null;return}
  var b=el('button','sp-chip'+(v.a?'':' is-out'),v.t);b.type='button';b.disabled=!v.a;if(!v.a)b.setAttribute('aria-label',v.t+', sold out');
  if(v.a&&v.q>0&&v.q<=3){var lq=v.q===1?'last one':v.q+' left';b.appendChild(el('i','sp-chip__q',lq));b.setAttribute('aria-label',v.t+', '+lq)}
  b.addEventListener('click',function(){[].forEach.call(L.sizes.children,function(x){x.classList.remove('is-on')});b.classList.add('is-on');look._v=v.id;L.msg.textContent=''});
  L.sizes.appendChild(b);
 });
 var any=vs.some(function(v){return v.a});L.add.disabled=!any;L.add.textContent=any?'Add to bag':'Sold out';
 L.eta.hidden=!(any&&w.SPEta);if(any&&w.SPEta)w.SPEta.fill(L.eta);
 look.classList.remove('in','out');
 if(look.showModal)look.showModal();else look.setAttribute('open','');
 d.documentElement.classList.add('sp-look-open');
 look.querySelector('.sp-look__scroll').scrollTop=0;
 var li=ctx.items[ctx.i];
 function go(){
  var from=src&&!reduce?contentRect(src):null,tf=from&&from.width?flip(from):'';
  if(tf){L.lift.style.transition='none';L.lift.style.transform=tf;li.classList.add('is-lifted');void L.lift.offsetWidth}
  requestAnimationFrame(function(){L.lift.style.transition='';L.lift.style.transform='';look.classList.add('in')});
 }
 if(L.front.complete&&L.front.naturalWidth)go();else{var once=false,g=function(){if(once)return;once=true;go()};L.front.addEventListener('load',g,{once:true});setTimeout(g,350)}
 L.x.focus({preventScroll:true});
}
function shut(toBag){
 if(!look||!look.open||look.classList.contains('out'))return;
 toBag=toBag===true;
 var L=look._,ctx=look._ctx,src=ctx&&srcImg(ctx),li=ctx&&ctx.items[ctx.i];
 look.classList.add('out');look.classList.remove('in');
 var r=src&&src.getBoundingClientRect(),vis=r&&r.bottom>0&&r.top<w.innerHeight&&!reduce;
 if(vis&&!look._s&&!toBag){L.lift.style.transform=flip(contentRect(src))}
 setTimeout(function(){
  if(look.close)look.close();else look.removeAttribute('open');
  d.documentElement.classList.remove('sp-look-open');look.classList.remove('out');
  L.lift.style.transition='none';L.lift.style.transform='';if(li)li.classList.remove('is-lifted');
  look._p=null;
  var a=li&&li.querySelector('.sp-rail__link');if(a)a.focus({preventScroll:true});
 },reduce||toBag?0:560);
}

/* ---------- runway: a 3D catwalk you can swipe, drag, flick or trackpad-swipe ---------- */
function runway(root){
 var stage=root.querySelector('.sp-runway__stage'),items=[].slice.call(root.querySelectorAll('.sp-runway__item'));
 if(!stage||!items.length)return;
 var big=root.querySelector('[data-sp-big]'),name=root.querySelector('[data-sp-name]'),price=root.querySelector('[data-sp-price]'),stockEl=root.querySelector('[data-sp-stock]'),link=root.querySelector('[data-sp-link]'),dots=root.querySelector('.sp-runway__dots');
 var n=items.length,pos={x:0,v:0,t:0},cur=-1,timer=null,drag=null,moved=false,W=0,SP=1,DZ=200,visible=true,hover=false,wraw=null,wt=0,cache=[],tr=tracker();
 root.classList.add('sp-runway--live');
 if(!stage.querySelector('.sp-runway__floor')){
  var fl=el('div','sp-runway__floor');fl.setAttribute('aria-hidden','true');stage.insertBefore(fl,stage.firstChild);
  if(!(w.SPFloor&&w.SPFloor(fl,'runway')))fl.appendChild(el('i'));
 }
 items.forEach(function(it){var im=it.querySelector('img');if(im){im.setAttribute('draggable','false');lift(im)}it.appendChild(el('span','sp-runway__shadow'));cache.push({})});
 if(dots){dots.textContent='';items.forEach(function(_,k){var b=el('button','sp-rail__dot');b.type='button';b.setAttribute('aria-label','Show piece '+(k+1));b.addEventListener('click',function(){go(pos.t+wrap(k-pos.t));restart()});dots.appendChild(b)})}
 function measure(){W=stage.clientWidth;var ph=W<750;SP=W*(ph?0.56:0.3);DZ=ph?280:260}
 function wrap(o){o=((o%n)+n)%n;if(o>n/2)o-=n;return o}
 function render(){
  for(var k=0;k<n;k++){var o=wrap(k-pos.x),a=Math.abs(o),it=items[k],c=cache[k];
   var x=o*SP*(1-Math.min(a,2.4)*0.1),z=-Math.min(a,2.6)*DZ,ry=clamp(-o*40,-58,58),op=clamp(a<1.7?1:clamp(2.6-a,0,1)/0.9,0,1);
   var t='translate3d('+x.toFixed(1)+'px,0,'+z.toFixed(1)+'px) rotateY('+ry.toFixed(2)+'deg)';if(c.t!==t){it.style.transform=t;c.t=t}
   var s=op.toFixed(3);if(c.o!==s){it.style.opacity=s;it.style.visibility=op<=0.01?'hidden':'';c.o=s}
   var zi=100-Math.round(a*10);if(c.z!==zi){it.style.zIndex=zi;c.z=zi}
   var ps=String(clamp(Math.round(o),-2,2));if(it.dataset.pos!==ps)it.dataset.pos=ps;
  }
  var i=((Math.round(pos.x)%n)+n)%n;if(i!==cur){cur=i;update(i)}
 }
 function update(i){
  var c=items[i];
  items.forEach(function(it,k){it.setAttribute('aria-hidden',k===i?'false':'true')});
  if(big){big.textContent=c.dataset.title||'';if(big.animate&&!reduce)big.animate([{opacity:0,transform:'translate3d(-46%,-50%,0)'},{opacity:1,transform:'translate3d(-50%,-50%,0)'}],{duration:900,easing:'cubic-bezier(.16,1,.3,1)'})}
  if(name)name.textContent=c.dataset.title||'';if(price)price.textContent=c.dataset.price||'';if(link)link.href=c.dataset.url||'#';
  if(stockEl){stockEl.textContent=c.dataset.stock||'';stockEl.hidden=!c.dataset.stock;stockEl.classList.toggle('is-last',!!c.dataset.last)}
  if(dots)[].forEach.call(dots.children,function(b,k){b.classList.toggle('is-on',k===i)});
 }
 /* quick and lively, with a small settle at the end */
 var kick=ticker(function(dt){
  if(!(drag&&drag.on)&&wraw===null){spring(pos,240,19,dt);settled(pos,0.0006)}
  render();
  return (drag&&drag.on)||wraw!==null||pos.x!==pos.t||pos.v!==0;
 });
 function go(k){pos.t=Math.round(k);if(reduce){pos.x=pos.t;pos.v=0;render();return}kick()}
 function stop(){clearInterval(timer);timer=null}
 function restart(){stop();if(n>1&&visible&&!hover&&!drag&&wraw===null)timer=setInterval(function(){go(pos.t+1)},reduce?7000:5200)}
 var pb=root.querySelector('[data-prev]'),nb=root.querySelector('[data-next]');
 if(pb)pb.addEventListener('click',function(){go(pos.t-1);restart()});
 if(nb)nb.addEventListener('click',function(){go(pos.t+1);restart()});
 stage.addEventListener('pointerdown',function(e){
  if((e.button&&e.button!==0)||(e.target.closest&&e.target.closest('button')))return;
  moved=false;drag={x:e.clientX,y:e.clientY,id:e.pointerId,on:false,p0:pos.x};tr.clear();tr.add(e.clientX,e.timeStamp);stop();
 });
 stage.addEventListener('pointermove',function(e){
  if(!drag||e.pointerId!==drag.id)return;var dx=e.clientX-drag.x,dy=e.clientY-drag.y;
  if(!drag.on){
   if(Math.abs(dx)>8&&Math.abs(dx)>Math.abs(dy)*1.1){drag.on=moved=true;drag.p0=pos.x;drag.x=e.clientX;dx=0;pos.v=0;try{stage.setPointerCapture(e.pointerId)}catch(x){}root.classList.add('is-drag')}
   else if(Math.abs(dy)>10){drag=null;restart();return}else return;
  }
  tr.add(e.clientX,e.timeStamp);pos.x=drag.p0-dx/SP;pos.t=pos.x;kick();
 });
 function end(e){
  if(!drag||e.pointerId!==drag.id)return;var dd=drag;drag=null;root.classList.remove('is-drag');
  if(dd.on){
   if(e.type!=='pointercancel')tr.add(e.clientX,e.timeStamp);
   var vi=e.type==='pointercancel'?0:-tr.vel()/SP,tg=Math.round(pos.x+clamp(vi*0.26,-1.6,1.6));
   if(tg===Math.round(dd.p0)&&Math.abs(pos.x-dd.p0)>0.18)tg=Math.round(dd.p0)+(pos.x>dd.p0?1:-1);
   pos.v=clamp(vi,-14,14);pos.t=tg;kick();
  }
  restart();
 }
 stage.addEventListener('pointerup',end);stage.addEventListener('pointercancel',end);
 stage.addEventListener('dragstart',function(e){e.preventDefault()});
 stage.addEventListener('wheel',function(e){
  var dx=sideways(e);if(!dx||(drag&&drag.on))return;e.preventDefault();stop();
  if(wraw===null)wraw=pos.x;wraw+=dx/SP;pos.x=pos.t=wraw;pos.v=0;
  clearTimeout(wt);wt=setTimeout(function(){wraw=null;go(pos.x);restart()},130);kick();
 },{passive:false});
 items.forEach(function(it,k){it.addEventListener('click',function(e){
  if(moved){e.preventDefault();moved=false;return}
  var o=wrap(k-pos.x);if(Math.abs(o)>0.5){e.preventDefault();go(pos.x+o);restart()}
  else if(link&&link.getAttribute('href')&&link.getAttribute('href')!=='#')link.click();
 })});
 if(fine){root.addEventListener('mouseenter',function(){hover=true;stop()});root.addEventListener('mouseleave',function(){hover=false;restart()})}
 root.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){go(pos.t+1);restart()}if(e.key==='ArrowLeft'){go(pos.t-1);restart()}});
 if('IntersectionObserver' in w)new IntersectionObserver(function(es){visible=es[0].isIntersecting;if(visible)restart();else stop()}).observe(root);
 d.addEventListener('visibilitychange',function(){if(d.hidden)stop();else restart()});
 measure();render();restart();
 if(w.ResizeObserver)new ResizeObserver(function(){measure();render()}).observe(stage);
}

function init(){
 d.querySelectorAll('[data-sp-rail]:not([data-ok])').forEach(function(r){r.setAttribute('data-ok','');rail(r)});
 d.querySelectorAll('[data-sp-runway]:not([data-ok])').forEach(function(r){r.setAttribute('data-ok','');runway(r)});
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
d.addEventListener('shopify:section:load',init);
})();
